import { render } from "./Search.vue?vue&type=template&id=6ca2aa64&bindings={\"app\":\"props\",\"q\":\"data\",\"debounceQ\":\"data\",\"highlight\":\"options\",\"highlightRegex\":\"options\",\"filteredPages\":\"options\"}"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script